import { useLayoutEffect, useContext, useState, useRef, useEffect } from 'preact/hooks';
import { UploadIcon } from '../ecardsPreact.icons/UploadIcon';
import { useField } from 'formik';
import { FieldError } from './FieldError';
import { Steps } from '../ecardsPreact.constants/steps';
import { ECardGlobalState } from './ECardGlobalState';

export const FileUploadField = ({ label, buttonText, wrapperClass, helpText, onChange, ...props }) => {
    const [field, meta, helpers] = useField(props);

    const fieldClassName = `form-field form-field--file${meta.error && meta.touched ? ' form-field--error' : ''}${wrapperClass ? ` ${wrapperClass}` : ''}`;

    const { currentStep } = useContext(ECardGlobalState);
    const [fileName, setFileName] = useState(null);
    const fileInput = useRef(null);

    // NOTE: were are handling the file upload validation in this component, not the main validation method due to how the file upload functionality works
    const handleFileClick = (event) => {
        fileInput.current.click();
    };

    const handleFileChange = async (event) => {
        const files = event.currentTarget.files;
        if (files.length) {
            const file = files[0];
            const fileName = file.name;
            const extension = fileName?.split('.').pop().toLowerCase();

            let fileError = '';
            if (file.size > 200000) {
                fileError += `The file size of the image you're trying to upload is too big. Please ensure you image is no more than 200kb. `;
            }
            if (extension !== 'png' && extension !== 'jpg' && extension !== 'jpeg' && extension !== 'gif') {
                fileError += 'Please upload a valid file type. Valid file types are .png, .jpg, .jpeg, .gif';
            }
            if (fileError.length > 0) {
                helpers.setError(fileError);
                helpers.setValue(null, false);
            } else {
                helpers.setValue(file, false);
                helpers.setError(null);
            }
        } else {
            helpers.setError(null);
            helpers.setValue(null, false);
        }

        if (onChange) {
            onChange(event);
        }
    };

    useLayoutEffect(
        (e) => {
            if (currentStep === Steps.Personalise) {
                setFileName(null);
            }
        },
        [currentStep]
    );

    useEffect(() => {
        if (field.value) {
            setFileName(field.value.name);
        } else {
            fileInput.current.value = null;
            setFileName(null);
        }
    }, [field.value]);

    return (
        <div class={fieldClassName}>
            <div class="form-field__label-wrapper">
                <label class="form-field__label label" htmlFor={field.name}>
                    {label}

                    {props.required && <span class="label__required">&nbsp;*</span>}
                </label>
            </div>

            <div class="file-selector__wrap file-selector__wrap--image-upload">
                <button class={`file-selector ${fileName ? '' : 'file-selector--placeholder'}`} type="button" onClick={handleFileClick}>
                    <div class="file-selector__text">{fileName || buttonText}</div>
                    <div class="file-selector__button">
                        <UploadIcon class="file-selector__icon" />
                    </div>
                </button>
                <input ref={fileInput} id={field.name} {...field} type="file" accept=".jpg, .jpeg, .png, .gif" onChange={handleFileChange} class="sr-only" />
                <FieldError touched={true} error={meta.error} />
            </div>

            {helpText && <p class="form-field__help-text">{helpText}</p>}
        </div>
    );
};
